import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./FailedToGetFileModal.css";

class FailedReportsParseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { fileFailedToGet, toggleFailedToGetModal } = this.props;

    return (
      <SweetAlert
        customClass="FailedReportsParseModal__SweetAlert"
        title=""
        showConfirm={false}
        onConfirm={() => {}}
      >
        <div className="FailedReportsParseModal__Header">
          Following files do not exist on AWS(S3)
          <br />
        </div>

        {fileFailedToGet.length > 0 && (
          <table className="FailedReportsParseModal__Table">
            <thead className="FailedReportsParseModal__Table__Thead">
              <tr>
                <th className="customTh FailedReportsParseModal__Table__Th">
                  #
                </th>
                <th className="customTh FailedReportsParseModal__Table__Th">
                  File
                </th>
              </tr>
            </thead>
            <tbody>
              {fileFailedToGet.map((file, i) => (
                <tr key={i}>
                  <td className="FailedReportsParseModal__Table__Td">
                    {" "}
                    {i + 1}
                    {" "}
                  </td>
                  <td className="FailedReportsParseModal__Table__Td">
                    {file}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div>
          <button
            type="button"
            className="FailedReportsParseModal__CloseBtn"
            onClick={() => toggleFailedToGetModal()}
          >
            Close
          </button>
        </div>
      </SweetAlert>
    );
  }
}

export default FailedReportsParseModal;
